import { Container, Element, Label } from '@playcanvas/pcui';

import { Events } from '../events';
import { localize } from './localization';
import { MenuPanel } from './menu-panel';
import arrowSvg from './svg/arrow.svg';
import collapseSvg from './svg/collapse.svg';
import selectDelete from './svg/delete.svg';
import sceneExport from './svg/export.svg';
import sceneImport from './svg/import.svg';
import sceneNew from './svg/new.svg';
import login from './svg/login.svg';
import logout from './svg/logout.svg';
import showSceneList from './svg/show-scenes.svg';
import sceneOpen from './svg/open.svg';
import scenePublish from './svg/publish.svg';
import sceneSave from './svg/save.svg';
import selectAll from './svg/select-all.svg';
import selectDuplicate from './svg/select-duplicate.svg';
import selectInverse from './svg/select-inverse.svg';
import selectLock from './svg/select-lock.svg';
import selectNone from './svg/select-none.svg';
import selectSeparate from './svg/select-separate.svg';
import selectUnlock from './svg/select-unlock.svg';
import logoSvg from './svg/biligoba-logo.png';
import imageImport from './svg/image-import.svg';
import imageConfigImport from './svg/image-config-import.svg';
import pdfFile from './svg/pdf-file.svg';

const createSvg = (svgString: string) => {
    const decodedStr = decodeURIComponent(svgString.substring('data:image/svg+xml,'.length));
    return new Element({
        dom: new DOMParser().parseFromString(decodedStr, 'image/svg+xml').documentElement
    });
};

import { AuthService } from '../auth';

class Menu extends Container {
    constructor(events: Events, authService: AuthService, args = {}) {
        args = {
            ...args,
            id: 'menu'
        };

        super(args);

        const menubar = new Container({
            id: 'menu-bar'
        });

        menubar.dom.addEventListener('pointerdown', (event) => {
            event.stopPropagation();
        });

        const iconDom = document.createElement('img');
        iconDom.src = logoSvg;
        iconDom.setAttribute('id', 'app-icon');

        const aDom = document.createElement('a');
        aDom.href = new URL(window.location.href).origin;
        aDom.target = '_blank';
        aDom.appendChild(iconDom);

        const icon = new Element({
            dom: aDom
        });

        const scene = new Label({
            text: localize('file'),
            class: 'menu-option'
        });

        const render = new Label({
            text: localize('render'),
            class: 'menu-option'
        });

        const account = new Label({
            text: localize('user.account'),
            class: 'menu-option'
        })

        // const selection = new Label({
        //     text: localize('select'),
        //     class: 'menu-option'
        // });

        const help = new Label({
            text: localize('help'),
            class: 'menu-option'
        });

        const toggleCollapsed = () => {
            document.body.classList.toggle('collapsed');
        };

        // collapse menu on mobile
        if (document.body.clientWidth < 600) {
            toggleCollapsed();
        }

        const collapse = createSvg(collapseSvg);
        collapse.dom.classList.add('menu-icon');
        collapse.dom.setAttribute('id', 'menu-collapse');
        collapse.dom.addEventListener('click', toggleCollapsed);

        const arrow = createSvg(arrowSvg);
        arrow.dom.classList.add('menu-icon');
        arrow.dom.setAttribute('id', 'menu-arrow');
        arrow.dom.addEventListener('click', toggleCollapsed);

        const buttonsContainer = new Container({
            id: 'menu-bar-options'
        });
        buttonsContainer.append(scene);
        // buttonsContainer.append(selection);
        buttonsContainer.append(render);
        buttonsContainer.append(account);
        buttonsContainer.append(help);
        buttonsContainer.append(collapse);
        buttonsContainer.append(arrow);

        menubar.append(icon);
        menubar.append(buttonsContainer);

        const exportMenuPanel = new MenuPanel([
            {
                text: localize('file.export.ply'),
                icon: createSvg(sceneExport),
                isEnabled: () => !events.invoke('scene.empty'),
                onSelect: () => events.invoke('scene.export', 'ply')
            },
            {
                text: localize('file.export.splat'),
                icon: createSvg(sceneExport),
                isEnabled: () => !events.invoke('scene.empty'),
                onSelect: () => events.invoke('scene.export', 'splat')
            }, {
                // separator
            }, {
                text: localize('file.export.viewer'),
                icon: createSvg(sceneExport),
                isEnabled: () => !events.invoke('scene.empty'),
                onSelect: () => events.invoke('scene.export', 'viewer')
            }]);

        const fileMenuPanel = new MenuPanel([{
            text: localize('file.new'),
            icon: createSvg(sceneNew),
            isEnabled: () => !events.invoke('scene.empty'),
            onSelect: () => events.invoke('doc.new')
        },
        // {
        //     text: localize('file.open'),
        //     icon: createSvg(sceneOpen),
        //     onSelect: async () => {
        //         await events.invoke('doc.open');
        //     }
        // }, 
        // {
        //     // separator
        // },
        // {
        //     text: localize('file.save'),
        //     icon: createSvg(sceneSave),
        //     isEnabled: () => events.invoke('doc.name'),
        //     onSelect: async () => await events.invoke('doc.save')
        // }, {
        //     text: localize('file.save-as'),
        //     icon: createSvg(sceneSave),
        //     isEnabled: () => !events.invoke('scene.empty'),
        //     onSelect: async () => await events.invoke('doc.saveAs')
        // }, 
        {
            // separator
        },
        // {
        //     text: localize('file.import'),
        //     icon: createSvg(sceneImport),
        //     onSelect: async () => {
        //         await events.invoke('scene.import');
        //     }
        // }, 
        {
            text: localize('file.import.blg'),
            icon: createSvg(sceneImport),
            isEnabled: () => events.invoke('scene.empty'),
            onSelect: async () => {
                await events.invoke('blg.open');
            }
        },
        // {
        //     text: localize('file.export'),
        //     icon: createSvg(sceneExport),
        //     subMenu: exportMenuPanel
        // }
        {

        },
        {
            text: localize('download.reference.pdf'),
            icon: createSvg(pdfFile),
            onSelect: async () => {
                await events.invoke('download.reference.pdf');
            }
        }
            // {
            //     // seperator
            // },
            // {
            //     text: localize('image.import'),
            //     icon: createSvg(imageImport),
            //     onSelect: async () => {
            //         await events.invoke('images.open')
            //     }
            // },
            // {
            //     text: localize('image-config.import'),
            //     icon: createSvg(imageConfigImport),
            //     onSelect: async () => {
            //         await events.invoke('poses.open')
            //     }
            // }
        ]);

        const accountMenuPanel = new MenuPanel([
            {
                text: localize('user.login'),
                icon: createSvg(login),
                isVisible: () => !authService.isAuthenticated(),
                onSelect: () => events.fire('user.login')
            },
            {
                text: localize('user.logout'),
                icon: createSvg(logout),
                isVisible: () => authService.isAuthenticated(),
                onSelect: () => events.fire('user.logout')
            },
            {
                text: localize('user.scenes'),
                icon: createSvg(showSceneList),
                isVisible: () => authService.isAuthenticated(),
                onSelect: () => events.fire('user.showScenes')
            }
        ]);

        events.on('user.authenticated', () => {
            accountMenuPanel.hidden = true; // refresh is handled by MenuPanel show listener
        });

        events.on('user.loggedOut', () => {
            accountMenuPanel.hidden = true;
        });

        const selectionMenuPanel = new MenuPanel([{
            text: localize('select.all'),
            icon: createSvg(selectAll),
            extra: 'Ctrl + A',
            onSelect: () => events.fire('select.all')
        }, {
            text: localize('select.none'),
            icon: createSvg(selectNone),
            extra: 'Shift + A',
            onSelect: () => events.fire('select.none')
        }, {
            text: localize('select.invert'),
            icon: createSvg(selectInverse),
            extra: 'Ctrl + I',
            onSelect: () => events.fire('select.invert')
        }, {
            // separator
        }, {
            text: localize('select.lock'),
            icon: createSvg(selectLock),
            extra: 'H',
            isEnabled: () => events.invoke('selection.splats'),
            onSelect: () => events.fire('select.hide')
        }, {
            text: localize('select.unlock'),
            icon: createSvg(selectUnlock),
            extra: 'U',
            onSelect: () => events.fire('select.unhide')
        }, {
            text: localize('select.delete'),
            icon: createSvg(selectDelete),
            extra: 'Delete',
            isEnabled: () => events.invoke('selection.splats'),
            onSelect: () => events.fire('select.delete')
        }, {
            text: localize('select.reset'),
            onSelect: () => events.fire('scene.reset')
        }, {
            // separator
        }, {
            text: localize('select.duplicate'),
            icon: createSvg(selectDuplicate),
            isEnabled: () => events.invoke('selection.splats'),
            onSelect: () => events.fire('select.duplicate')
        }, {
            text: localize('select.separate'),
            icon: createSvg(selectSeparate),
            isEnabled: () => events.invoke('selection.splats'),
            onSelect: () => events.fire('select.separate')
        }]);

        const renderMenuPanel = new MenuPanel([{
            text: localize('render.image'),
            icon: createSvg(sceneExport),
            onSelect: async () => await events.invoke('show.imageSettingsDialog')
        }, {
            text: localize('render.video'),
            icon: createSvg(sceneExport),
            onSelect: async () => await events.invoke('show.videoSettingsDialog')
        }]);

        const helpMenuPanel = new MenuPanel([{
            text: localize('help.shortcuts'),
            icon: 'E136',
            onSelect: () => events.fire('show.shortcuts')
        }, {
            // separator
        }, {
            text: localize('help.about'),
            icon: 'E138',
            onSelect: () => events.invoke('show.about')
        }]);

        this.append(menubar);
        this.append(fileMenuPanel);
        this.append(exportMenuPanel);
        this.append(selectionMenuPanel);
        this.append(renderMenuPanel);
        this.append(accountMenuPanel);
        this.append(helpMenuPanel);

        const options: { dom: HTMLElement, menuPanel: MenuPanel }[] = [{
            dom: scene.dom,
            menuPanel: fileMenuPanel
        },
        // {
        //     dom: selection.dom,
        //     menuPanel: selectionMenuPanel
        // },
        {
            dom: account.dom,
            menuPanel: accountMenuPanel
        },
        {
            dom: render.dom,
            menuPanel: renderMenuPanel
        }, {
            dom: help.dom,
            menuPanel: helpMenuPanel
        }];

        options.forEach((option) => {
            const activate = () => {
                option.menuPanel.position(option.dom, 'bottom', 2);
                options.forEach((opt) => {
                    opt.menuPanel.hidden = opt !== option;
                });
            };

            option.dom.addEventListener('pointerdown', (event: PointerEvent) => {
                if (!option.menuPanel.hidden) {
                    option.menuPanel.hidden = true;
                } else {
                    activate();
                }
            });

            option.dom.addEventListener('pointerenter', (event: PointerEvent) => {
                if (!options.every(opt => opt.menuPanel.hidden)) {
                    activate();
                }
            });
        });

        const checkEvent = (event: PointerEvent) => {
            if (!this.dom.contains(event.target as Node)) {
                options.forEach((opt) => {
                    opt.menuPanel.hidden = true;
                });
            }
        };

        window.addEventListener('pointerdown', checkEvent, true);
        window.addEventListener('pointerup', checkEvent, true);
    }
}

export { Menu };
